<div class="App" id="AppWrapper">
  <app-notification type="sessionTimeout"></app-notification>
  <header class="py-0 border-bottom align-middle fixed-top bg-theme-{{ theme }}">
    <div class="visually-hidden-focusable overflow-hidden border-bottom">
      <a class="d-inline-flex p-2 m-1text-dark text-decoration-none" href="#content">Skip to main content</a>
      <a class="d-none d-md-inline-flex p-2 m-1 text-dark text-decoration-none" href="#navigation">Skip to navigation</a>
    </div>
    <nav class="navbar navbar-expand-lg py-0">
      <div class="container-fluid">
        <a class="navbar-brand border-end me-1 pe-2 my-0 py-2" href="https://usask.ca">
          <img src="/assets/img/uofs-crest.webp" height="34" class="" alt="University of Saskatchewan" />
          <!--                    <img src="/assets/img/uofs-logo.webp" height="34" class="d-lg-block d-none" alt="University of Saskatchewan" />-->
        </a>
        <ul class="navbar-nav me-auto">
          <li class="nav-item">
            <a class="nav-link" [routerLink]="['/']">
              <img src="{{ logoImg }}" height="26" style="margin:5px;" alt="Paws Home" />
            </a>
            <!--                        <a class="nav-link d-md-none" href="/"><img src="{{ logoImgMobile }}" height="26" style="margin:5px;" alt="Paws Home" /></a>-->
          </li>
          <li>
            <div class="me-1 pe-2 my-0 py-2 fs-4 text-primary fw-semibold d-none d-lg-block">
              {{ headerText }}
            </div>
          </li>
        </ul>
        @if ( isLoggedIn() ) {
          <!--                <div class="alert alert-success m-1 px-4 py-2 me-auto" id="paws-toast">This application has been updated!. <a href="/" class="btn btn-secondary btn-sm">Reload Now</a></div>-->
          <div class="mx-auto d-sm-block d-none" id="usask-search">
              <input type="text" class="form-control me-0" placeholder="Search PAWS and Knowledgebase" [formControl]="searchTerm" (keyup.enter)="submitSearch()" />
              <div class="search-actions">
                @if (showUChatAssistant) {
                  <button class="ask-ai-button" type="button" aria-label="Ask AI - Open PAWS Digital Agent" title="Ask AI" (click)="submitAISearch()">
                    <img src="/assets/img/paw-green.png" height="20" alt="" />
                    <span>Ask AI</span>
                  </button>
                }
                <button type="button" class="btn btn-link" (click)="submitSearch()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16" style="font-size:1.4rem;">
                  <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                  </svg><span class="visually-hidden">Search</span>
                </button>
              </div>
          </div>

          <app-navigation isMobile="true"></app-navigation>

          <ul class="navbar-nav ms-auto d-md-block d-none">
            <li class="nav-item">
              <div ngbDropdown class="dropdown d-inline-block" placement="bottom-end">
                <button type="button" class="btn btn-link mx-1 fw-bold text-black" id="dropdown_list" ngbDropdownToggle title="Available to" style="text-decoration: none;">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-fill fs-5 text-black" viewBox="0 0 16 16">
                    <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
                  </svg> {{ userName }}
                </button>
                <div ngbDropdownMenu class="bg-white">
                  <button ngbDropdownItem class="dropdown-item"><a class="dropdown-item" href="{{ myProfileLink }}" target="_blank">My Profile</a></button>
                  @if ( showO365Logout ) {
                    <button ngbDropdownItem class="dropdown-item"><a class="dropdown-item" href="#" (click)="logoutO365()">Disconnect O365</a></button>
                  }
                  <button ngbDropdownItem class="dropdown-item"><a class="dropdown-item" href="{{ helpLink }}" target="_blank">Help</a></button>
                  <div class="dropdown-divider"></div>
                  <button ngbDropdownItem class="dropdown-item"><a class="dropdown-item" [routerLink]="['/logout']">Sign out</a></button>
                </div>
              </div>
            </li>
          </ul>
        }
      </div>
    </nav>
    <div class="container-fluid d-sm-none">
      <div class="mx-auto" id="usask-search-mobile">
          <input type="text" class="form-control me-0" placeholder="Search PAWS and Knowledgebase" [formControl]="searchTerm" (keyup.enter)="submitSearch()" />
          <div class="search-actions">
            @if (showUChatAssistant) {
              <button class="ask-ai-button" type="button" aria-label="Ask AI - Open PAWS Digital Agent" title="Ask AI" (click)="submitAISearch()">
                <img src="/assets/img/paw-green.png" height="20" alt="" />
                <span>Ask AI</span>
              </button>
            }
            <button type="button" class="btn btn-link" (click)="submitSearch()">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16" style="font-size:1.4rem;">
              <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
              </svg><span class="visually-hidden">Search</span>
            </button>
          </div>
      </div>
    </div>

  </header>
  <div class="d-flex align-items-stretch bd-highlight row m-0 align-items-stretch" id="contentWrapper">
    @if (isLoggedIn()) {
      <div class="p-2 pt-3 col-xxl-2 col-xl-2 col-md-3 col-xs-0 d-none d-md-block d-lg-block bg-paws">
        <app-navigation isMobile="false"></app-navigation>
      </div>
    }
    <div class="col-xs-12 p-0 bg-white" [class.col-xl-10]="isLoggedIn()" [class.col-xxl-10]="isLoggedIn()" [class.col-md-9]="isLoggedIn()">
      @if (!isIframe) {
        <router-outlet></router-outlet>
      }
    </div>

  </div>
  <div id="backtotop">
    @if (showBackToTop()) {
      <button class="btn btn-lg" (click)="scrollToTop()">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-up-fill" viewBox="0 0 16 16">
          <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
        </svg>
      </button>
    }
  </div>
</div>
